class NovalatteCart {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    this.backdrop = document.getElementById('CartDrawerBackdrop');
    this.itemsContainer = document.getElementById('CartItemsContainer');
    this.skeleton = document.getElementById('CartSkeleton');
    
    // Configuración de Metas (Rewards)
    this.freeShippingThreshold = 5000; // $50.00 (en centavos)
    this.freeGiftThreshold = 8500;     // $85.00 (en centavos)
    
    this.init();
  }

  init() {
    // Listeners
    document.querySelectorAll('.js-open-cart').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    this.backdrop.addEventListener('click', () => this.close());
    document.getElementById('CartDrawerClose').addEventListener('click', () => this.close());
    
    // Initial Fetch
    this.fetchCart();
  }

  open() {
    this.drawer.classList.add('is-open');
    this.backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden'; // Evita scroll en el fondo
  }

  close() {
    this.drawer.classList.remove('is-open');
    this.backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  // CORE: Fetch Cart Data
  async fetchCart() {
    this.showSkeleton(true);
    const response = await fetch('/cart.js');
    const cart = await response.json();
    this.renderCart(cart);
    this.showSkeleton(false);
  }

  // RENDER: Construye el HTML dinámicamente
  renderCart(cart) {
    // 1. Update Footer Price
    document.getElementById('CartSubtotal').innerText = this.formatMoney(cart.total_price);
    document.getElementById('CartTotalBtn').innerText = this.formatMoney(cart.total_price);

    // 2. Update Progress Bar logic
    this.updateProgressBar(cart.total_price);

    // 3. Render Items
    if (cart.item_count === 0) {
      this.itemsContainer.innerHTML = `
        <div class="nl-cart-empty">
          <h3 class="nl-drawer__title">YOUR RITUAL AWAITS.</h3>
          <p>Balance is just a few clicks away.</p>
          <button onclick="location.href='/collections/all'" class="nl-btn nl-btn--checkout" style="margin-top:20px;">EXPLORE FLAVORS</button>
        </div>
      `;
    } else {
      let html = '';
      cart.items.forEach(item => {
        html += `
          <div class="nl-item">
            <img src="${item.image}" alt="${item.title}" class="nl-item__image">
            <div class="nl-item__details">
              <h4 class="nl-item__title">${item.product_title}</h4>
              <span class="nl-item__variant">${item.variant_title || ''}</span>
              
              <div class="nl-sub-toggle">
                <span>↻ Subscribe & Save 15%</span>
              </div>

              <div class="nl-item__controls" style="margin-top:10px;">
                <div class="nl-qty">
                  <button class="nl-qty__btn" onclick="cartDrawer.changeQty('${item.key}', ${item.quantity - 1})">-</button>
                  <input type="text" class="nl-qty__input" value="${item.quantity}" readonly>
                  <button class="nl-qty__btn" onclick="cartDrawer.changeQty('${item.key}', ${item.quantity + 1})">+</button>
                </div>
                <div class="nl-item__price">${this.formatMoney(item.final_line_price)}</div>
              </div>
              <div style="text-align:right; margin-top:5px;">
                <span class="nl-item__remove" onclick="cartDrawer.changeQty('${item.key}', 0)">Remove</span>
              </div>
            </div>
          </div>
        `;
      });
      this.itemsContainer.innerHTML = html;
    }
  }

  // LOGIC: Change Quantity
  async changeQty(key, newQty) {
    this.showSkeleton(true);
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    this.fetchCart(); // Re-fetch to update everything
  }

  // LOGIC: Progress Bar & Rewards
  updateProgressBar(total) {
    const bar = document.getElementById('RewardsBar');
    const text = document.getElementById('RewardsText');
    const amountSpan = document.getElementById('RewardsAmount');

    // Calculate Percentage based on highest tier
    let percentage = (total / this.freeGiftThreshold) * 100;
    if (percentage > 100) percentage = 100;
    bar.style.width = `${percentage}%`;

    // Dynamic Text
    if (total < this.freeShippingThreshold) {
      let remaining = this.freeShippingThreshold - total;
      text.innerHTML = `You are <b>${this.formatMoney(remaining)}</b> away from complimentary shipping.`;
    } else if (total >= this.freeShippingThreshold && total < this.freeGiftThreshold) {
      let remaining = this.freeGiftThreshold - total;
      text.innerHTML = `Shipping unlocked! Add <b>${this.formatMoney(remaining)}</b> for a free gift.`;
    } else {
      text.innerHTML = `✨ <b>All rewards unlocked.</b> Your ritual is ready.`;
    }
  }

  showSkeleton(isLoading) {
    if (isLoading) {
      this.itemsContainer.style.display = 'none';
      this.skeleton.classList.add('is-active');
    } else {
      this.itemsContainer.style.display = 'block';
      this.skeleton.classList.remove('is-active');
    }
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
}

// Initialize Global Instance
const cartDrawer = new NovalatteCart();